import React from "react";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import TenantHeader from "../TenantHeader";
import { useTenantBranding } from "../hooks/useTenantBranding";
import QRCode from "react-qr-code";
import authService from "../../services/authService";
import "../rapport/Rapport.css";

const RapportQR = () => {
  const { publicId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const branding = useTenantBranding();
  const examen = location.state?.examen;

  if (!examen) return <p>Chargement…</p>;

  const calculerAge = (dateNaissance) => {
    if (!dateNaissance) return "—";
    const naissance = new Date(dateNaissance);
    const maintenant = new Date();
    let age = maintenant.getFullYear() - naissance.getFullYear();
    const mois = maintenant.getMonth() - naissance.getMonth();
    if (mois < 0 || (mois === 0 && maintenant.getDate() < naissance.getDate())) {
      age--;
    }
    return age + " ans";
  };

  const openOHIFViewer = (examId) => {
    const url = process.env.REACT_APP_VIEWER_URL + `/viewer/${examId}`;
    const windowFeatures = "width=800,height=600,resizable,scrollbars=yes";
    const newWindow = window.open(url, "_blank", windowFeatures);
    if (newWindow) newWindow.focus();
    else alert("La fenêtre pop-up a été bloquée par votre navigateur.");
  };

  return (
    <div className="report-container">
      {/* ✅ Boutons en haut de page */}
      <div className="buttons">
        <button onClick={() => navigate("/accueil")}>
          <span role="img" aria-label="acceuil">🏠</span>Retour à l’accueil
        </button>

        <button className="btn btn-blue" onClick={() => window.location.reload()}>
          <span role="img" aria-label="Actualiser">🔄</span>Actualiser
        </button>

        <button className="save-button">
          <Link to={`/examens/${publicId}`}>
            <span role="img" aria-label="Éditer">✏️</span> Retour examen
          </Link>
        </button>

        <button className="btn btn-green" onClick={() => window.print()}>
          <span role="img" aria-label="Générer">🖨️</span> Imprimer
        </button>

        {(authService.isRadiologue() || authService.isTechnicien()) && (
          <button
            className="btn btn-purple"
            onClick={() => openOHIFViewer(examen.dicom?.[0]?.study)}
          >
            <span role="img" aria-label="Visualiser">👁️</span> Visualiser les images
          </button>
        )}
      </div>

      {/* ✅ En-tête clinique */}
      <TenantHeader branding={branding} />

      {/* ✅ Titre */}
      <div className="title-block">
        <h2 className="title">QR Code Examen</h2>
      </div>

      {/* ✅ Infos patient */}
      <div className="patient-info">
        <div className="row">
          <span className="label">NOM :</span>
          <span className="line">{examen.patient?.personne?.nom || ""}</span>

          <span className="label">PRÉNOM :</span>
          <span className="line">{examen.patient?.personne?.prenom || ""}</span>
        </div>

        <div className="row">
          <span className="label">ÂGE :</span>
          <span className="line">
            {examen.patient?.personne?.date_naissance
              ? calculerAge(examen.patient.personne.date_naissance)
              : "—"}
          </span>

          <span className="label">SEXE :</span>
          <span className="line">{examen.patient?.personne?.sexe || ""}</span>
        </div>
      </div>

      {/* ✅ QR Code centré */}
      <div className="qr-section" style={{ textAlign: "center", marginTop: "40px" }}>
        <QRCode value={`https://eurekapacs.app/public/viewer/${publicId}`} size={200} />
        <div className="qr-caption" style={{ marginTop: "10px", fontStyle: "italic" }}>
          Scanner ce QR pour accéder aux images de l’examen
        </div>
      </div>
    </div>
  );
};

export default RapportQR;
